import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type StartCopyAssetsOperationMutationVariables = Types.Exact<{
  input: Types.StartCopyAssetsOperationInput;
}>;


export type StartCopyAssetsOperationMutation = { __typename?: 'Mutation', startCopyAssetsOperation?: { __typename?: 'StartCopyAssetsOperationPayload', assetOperation?: { __typename?: 'CopyAssetsOperation', id?: string | null } | { __typename?: 'DeleteAssetsOperation', id?: string | null } | { __typename?: 'HardDeleteAssetsOperation', id?: string | null } | { __typename?: 'MoveAssetsOperation', id?: string | null } | { __typename?: 'UpdateAssetFieldValuesOperation', id?: string | null } | null } | null };


export const StartCopyAssetsOperation = /*#__PURE__*/ gql`
    mutation StartCopyAssetsOperation($input: StartCopyAssetsOperationInput!) {
  startCopyAssetsOperation(input: $input) {
    assetOperation {
      id
    }
  }
}
    ` as unknown as DocumentNode<StartCopyAssetsOperationMutation, StartCopyAssetsOperationMutationVariables>;

          

          export const useStartCopyAssetsOperationMutation = (options?:MutationHookOptions<StartCopyAssetsOperationMutation, StartCopyAssetsOperationMutationVariables>) => useMutation(StartCopyAssetsOperation, options);
          

          export type StartCopyAssetsOperationMutationOptions = MutationHookOptions<StartCopyAssetsOperationMutation, StartCopyAssetsOperationMutationVariables>;

          

          export type StartCopyAssetsOperationMutationResult = ReturnType<typeof useStartCopyAssetsOperationMutation>[1];

          
